// 用户中心
import AccountDetail from '../view/User/AccountDetail'
import NeedHandle from '../view/User/NeedHandle'
import SuggestionsDetail from '../view/User/SuggestionsDetail'
import ApprovalDetails from '../view/User/ApprovalDetails'

export default [
    /* 用户中心 */
    {
        path: '/user_center/account_detail',
        name: 'account-detail',
        components: {
            a: AccountDetail
        }
    },
    {
        path: '/user_center/need_handle',
        name: 'need-handle',
        components: {
            a: NeedHandle
        }
    },
    {
        path: '/user_center/suggestions_details/:id',
        name: 'suggestions-details',
        components: {
            a: SuggestionsDetail
        }
    },
    {
        path: '/user_center/approval_details/:type/:id',
        name: 'approval-details',
        components: {
            a: ApprovalDetails
        }
    },
    /* 用户中心 */
]


// WEBPACK FOOTER //
// ./src/router/User.js